import React, { Fragment, useState, useRef, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const HiddenSection = styled.div`
  width: 0;
  overflow: hidden;
`;

const Image = styled.img`
  width: 180px;
`;

const Information = styled.div`
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LoadingContainer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  > h4 {
    margin-right: 8px;
  }
`;

const ScannerDevice = ({ id, endpoint }) => {
  const [referenceNo, setReferenceNo] = useState("");
  const [scanned, setScanned] = useState(false);
  const inputReferenceNo = useRef(null);

  useEffect(() => {
    reset();
  }, []);

  const reset = () => {
    inputReferenceNo.current.focus();
    inputReferenceNo.current.value = "";
    setScanned(false);
    setReferenceNo("");
  };

  const handleSubmit = (e) => {
    console.log("scanned: ", scanned);
    if (!scanned) {
      e.preventDefault();
      e.stopPropagation();
      setScanned(true);

      const form = e.currentTarget;
      const formData = Object.fromEntries(new FormData(form));
      const scanned = formData.referenceNo;
      setReferenceNo(scanned);

      axios
        .post(endpoint, { id, scanned })
        .then((res) => {
          Swal.fire({
            title: "Success",
            text: referenceNo,
            icon: "success",
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((err) => {
          Swal.fire({
            title: referenceNo,
            text: err.response.data.errors?.base,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .finally(() => {
          reset();
        });
    }
  };

  return (
    <Fragment>
      <Container>
        <Wrapper>
          <Information>
            <h2>Scan Barcode with the Reader</h2>
          </Information>
          <LoadingContainer>
            {scanned ? (
              <h4 className="text-success lead">{`Scanned ${referenceNo}`}</h4>
            ) : (
              <Fragment>
                <h4 className="text-primary lead">Waiting for detection</h4>
                <div className="spinner-grow text-primary" role="status" />
                <div className="spinner-grow text-primary" role="status" />
                <div className="spinner-grow text-primary" role="status" />
              </Fragment>
            )}
          </LoadingContainer>
        </Wrapper>
      </Container>
      <HiddenSection>
        <form onSubmit={handleSubmit}>
          <input
            name="referenceNo"
            autoFocus
            ref={inputReferenceNo}
            onBlur={reset}
          />
        </form>
      </HiddenSection>
    </Fragment>
  );
};

export default ScannerDevice;
